import { Component, computed, ChangeDetectionStrategy } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import {
  pathRouteDataHelper$,
  pathRouteParametersHelper$,
} from "../../../shared/helpers/path-params.helper";
import { DefaultProduct } from "../../../shared/pia-api/generated";
import { CompetitorCompareSelect } from "../competitor-compare-select/competitor-compare-select";
import { ProductCompareSelect } from "../product-compare-select/product-compare-select";

@Component({
  selector: "claas-products-comparisons-selects",
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    ProductCompareSelect,
    CompetitorCompareSelect,
  ],
  templateUrl: "./products-comparisons-selects.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./products-comparisons-selects.scss",
})
export class ProductsComparisonsSelects {
  data = toSignal(pathRouteDataHelper$());
  params = toSignal(pathRouteParametersHelper$());

  productDescendants = computed((): DefaultProduct[] => {
    return this.data()?.["productDescendants"] ?? [];
  });
}
